import { combineReducers } from 'redux';

import loadFaviconError from './loadFaviconError';
import uploadFaviconError from './uploadFaviconError';
import deleteFaviconError from './deleteFaviconError';


export default combineReducers({
  loadFaviconError,
  uploadFaviconError,
  deleteFaviconError,
});
